<template>
  <div class="relative">
    <div
      :class="`fixed ${bottomValue} ${bottomValueTour} right-[20px] cursor-pointer z-50`"
    >
      <Icon
        alt="contact-us-wa"
        name="logos:whatsapp-icon"
        size="50"
        @click="togglePopover"
      />
    </div>

    <!-- Popover Content -->
    <div
      v-if="isOpen"
      v-click-outside="closePopover"
      class="fixed bottom-[160px] sm:bottom-[80px] right-[25px] w-[85%] sm:w-[400px] bg-slate-100 shadow-lg rounded-xl rounded-br-none p-4 border border-gray-200 z-50"
    >
      <p class="text-gray-700 mb-2 font-semibold">Need help? Chat with us!</p>
      <form @submit.prevent="onSubmit">
        <div
          class="flex flex-col rounded-xl sm:rounded-tl-none rounded-tr-xl sm:mx-auto gap-4"
        >
          <MazInput
            v-model="model.name"
            label="Your Name"
            autocomplete="off"
            :hint="errorMessages.name"
            :error="!!errorMessages.name"
            :success="fieldsStates.name.valid"
            :class="{ 'has-error': !!errorMessages.name }"
          />
          <MazInput
            v-model="model.email"
            label="Your Email"
            autocomplete="off"
            :hint="errorMessages.email"
            :error="!!errorMessages.email"
            :success="fieldsStates.email.valid"
            :class="{ 'has-error': !!errorMessages.email }"
          />
          <MazPhoneNumberInput
            v-model="model.phone"
            id="input-phone-data"
            :hint="errorMessages.phone"
            :error="!!errorMessages.phone"
            :success="fieldsStates.phone.valid"
            :class="{ 'has-error': !!errorMessages.phone }"
            label="Whatsapp Number"
            default-country-code="ID"
          />

          <MazBtn
            id="btn-reservation-submit"
            :loading="isSubmitting"
            :disabled="loading"
            type="submit"
            class="w-full lg:w-1/3"
          >
            <span>Chat Now</span>
          </MazBtn>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
const gtm: any = useGtm();
import type { InferFormValidatorSchema } from "maz-ui";
import { addAds } from "~/api/ads";
import { vClickOutside } from "maz-ui";
import { string, nonEmpty, pipe, email } from "valibot";

const isOpen = ref(false);
const loading = ref(false);
const route = useRoute();

const bottomValue = computed(() =>
  ((route?.name as string) || "").includes("bike-slug")
    ? "bottom-[90px]"
    : "bottom-[20px]"
);

const bottomValueTour = computed(() =>
  ((route?.name as string) || "").includes("tour-package-slug")
    ? "bottom-[75px]"
    : "bottom-[20px]"
);

// Form
const defaultSchema = {
  name: pipe(string(), nonEmpty("Name is required")),
  phone: pipe(string(), nonEmpty("Phone is required")),
  email: pipe(string(), nonEmpty("Email is required")),
};

const defaultFieldStates = {
  name: "",
  phone: "",
  email: "",
};

const schema = ref<any>(defaultSchema);
type Model = InferFormValidatorSchema<typeof schema>;

const { model, isSubmitting, handleSubmit, errorMessages, fieldsStates } =
  useFormValidator<Model>({
    schema,
    defaultValues: defaultFieldStates,
    options: { mode: "lazy", scrollToError: ".has-error" },
  });

const closeSuccess = () => {
  schema.value = {
    name: string(),
    phone: string(),
    vehicle_type: string(),
    email: email(),
  };
  model.value = { ...defaultFieldStates };
  setTimeout(() => {
    schema.value = { ...defaultSchema };
  }, 100);
};

const onSubmit = handleSubmit(async (formData) => {
  let submitData = <any>{};
  Object.assign(submitData, formData);

  try {
    loading.value = true;
    const { status } = await addAds({
      ...submitData,
    });

    if (status) {
      setTimeout(() => {
        closeSuccess();
        gtm.trackEvent({
          event: "btn-contact-us-ads",
          action: "click",
          value: 1,
        });

        window.open("https://wa.me/62811194881", "_blank");
      }, 0);
    }
  } catch (error) {
    console.error("Failed to submit data ads:", error);
  } finally {
    loading.value = false;
  }
});

// Action
const togglePopover = (event: any) => {
  event.stopPropagation();
  isOpen.value = !isOpen.value;
};

const closePopover = () => {
  isOpen.value = false;
};
</script>
